module.exports = __webpack_public_path__ + "static/media/Kawaii-100.6d70a1ba.webp";